import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'

const FooterNav = () => {
  const data = useStaticQuery(graphql`
    query GetNavLinks {
      allSanityPromotion(sort: { fields: name, order: ASC }) {
        nodes {
          id
          name
          gatsbyPath(filePath: "/promotion/{SanityPromotion.slug__current}")
        }
      }
      allSanityYear(sort: { fields: name, order: ASC }) {
        nodes {
          id
          name
          gatsbyPath(filePath: "/year/{SanityYear.slug__current}")
        }
      }

      allSanityCollection(sort: { fields: name, order: ASC }) {
        nodes {
          id
          name
          gatsbyPath(filePath: "/collection/{SanityCollection.slug__current}")
          promotions {
            abbreviation
          }
        }
      }
    }
  `)

  const promotions = data?.allSanityPromotion?.nodes ?? {}
  const years = data?.allSanityYear?.nodes ?? {}
  const collections = data?.allSanityCollection?.nodes ?? {}

  const nwawcwCollections = collections.filter((collection) =>
    collection.promotions.some(
      (promotion) =>
        promotion.abbreviation === 'NWA' || promotion.abbreviation === 'WCW',
    ),
  )

  const wwfCollections = collections.filter((collection) =>
    collection.promotions.some((promotion) => promotion.abbreviation === 'WWF'),
  )

  return (
    <Wrapper className="nav">
      <ul>
        <li>
          <ul>
            {promotions.map((promotion) => (
              <li key={promotion.id}>
                <Link to={promotion.gatsbyPath}>{promotion.name}</Link>
              </li>
            ))}
          </ul>
        </li>
        <li>
          <ul className="mod-year">
            {years.map((year) => (
              <li key={year.id}>
                <Link to={year.gatsbyPath}>{year.name}</Link>
              </li>
            ))}
          </ul>
        </li>
        <li>
          <ul>
            {nwawcwCollections.map((collection) => (
              <li key={collection.id}>
                <Link to={collection.gatsbyPath}>{collection.name}</Link>
              </li>
            ))}
          </ul>
        </li>
        <li>
          <ul>
            {wwfCollections.map((collection) => (
              <li key={collection.id}>
                <Link to={collection.gatsbyPath}>{collection.name}</Link>
              </li>
            ))}
          </ul>
        </li>
      </ul>
    </Wrapper>
  )
}

const Wrapper = styled.nav`
  margin: 0 0 var(--size-8);

  @media (min-width: 768px) {
    margin: 0;
  }

  > ul {
    display: grid;
    grid-template-columns: minmax(0, minmax(0, 1fr));
    grid-template-rows: auto;
    grid-gap: var(--size-4);
    font-family: var(--font-display);
    font-size: var(--font-size-4);
    line-height: 1.1;
    text-transform: uppercase;
    width: 100%;

    @media (min-width: 480px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-template-rows: 1fr;
    }

    @media (min-width: 768px) {
      grid-template-columns: repeat(auto-fit, minmax(0, max-content));
      grid-template-rows: 1fr;
      justify-content: end;
      grid-gap: var(--size-8);
    }

    a {
      color: var(--color-text1);
      transition: opacity 250ms;

      &:hover {
        opacity: 0.7;
      }
    }
  }

  ul.mod-year {
    display: flex;

    @media (min-width: 768px) {
      display: block;
    }

    li {
      &:not(:last-child)::after {
        content: '•';
        margin: 0 0.2em;
        @media (min-width: 768px) {
          content: none;
          margin: 0;
        }
      }
    }
  }
`

export default FooterNav
